import { render, staticRenderFns } from "./AddressFormNew.vue?vue&type=template&id=d9132400&"
import script from "./AddressFormNew.vue?vue&type=script&lang=js&"
export * from "./AddressFormNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/address_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FForm%2FForms%2FAddressFormNew.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports